import reactLogo from '../assets/valluvaricon.png'

function SideBar()
{
    return(
        <div className="sidebar-view">
            <h4>Thiruvalluvar</h4>
            <img className="sidebar-image" src={reactLogo} alt="Valluvar Logo"></img> 
            <p>"Unlock Thiruvalluvar's Wisdom, Illuminate Life's Path."</p> 
            <p>"திருவள்ளுவரின் ஞானத்தை விளக்குக, வாழ்க்கையின் வழியை வெளிப்படுத்துங்கள்."</p>  
        </div>
    );
}

export default SideBar;